import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

interface Props {
  degradedFor: string[];
}

export function DegradedBanner({ degradedFor }: Props) {
  if (degradedFor.length === 0) return null;
  // Deduplicate names from the four data sources we aggregate (one per fan-out
  // endpoint, so the same service can appear multiple times if more than one
  // upstream call to it failed).
  const unique = Array.from(new Set(degradedFor));
  return (
    <Alert color="orange" icon={<IconAlertTriangle size={18} />} title="Some data unavailable">
      Couldn&rsquo;t reach: {unique.join(', ')}. Other cards reflect the most recent successful
      response.
    </Alert>
  );
}
